module.exports = __webpack_public_path__ + "static/maintenance-c6a537aaeed54281c4ea3163ab79a334.jpg";